import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("If that email is registered, we've sent a reset link.");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F4F1EE] px-6 py-16">
      <div className="w-full max-w-md">
        <Link to="/" className="font-display text-xl text-[#1A362D]" data-testid="brand-link">← Trackr</Link>
        <h1 className="font-display text-4xl mt-8">Reset your password</h1>
        <p className="text-[#5C6B64] mt-2">Enter the email you used to sign up.</p>

        {sent ? (
          <div className="mt-8 rounded-2xl bg-[#E2F0E7] border border-[#1A362D]/10 p-6" data-testid="forgot-sent">
            <p className="text-[#1A362D] font-medium">Check your inbox</p>
            <p className="text-[#5C6B64] mt-2 text-sm">
              If an account exists for {email}, a reset link is on its way. The link expires in 1 hour.
            </p>
            <p className="text-[#5C6B64] mt-3 text-xs">
              Note: In this preview environment, the link is written to the backend logs. Ask your admin or run
              <code className="bg-white px-1.5 py-0.5 rounded mx-1 text-[#1A362D]">tail /var/log/supervisor/backend.err.log</code>
              to retrieve it.
            </p>
            <Link to="/login" className="inline-block mt-4 text-sm underline underline-offset-4 text-[#1A362D]">
              Back to sign in
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4 mt-8">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                className="h-12 mt-1.5 bg-white" data-testid="forgot-email-input" />
            </div>
            <Button
              type="submit" disabled={loading}
              className="w-full h-12 rounded-full bg-[#1A362D] hover:bg-[#2C4A40] text-white"
              data-testid="forgot-submit-btn"
            >
              {loading ? "Sending…" : "Send reset link"}
            </Button>
          </form>
        )}

        <p className="text-sm text-[#5C6B64] mt-6 text-center">
          Remembered it?{" "}
          <Link to="/login" className="underline underline-offset-4 text-[#1A362D]" data-testid="back-to-login-link">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
